class DateHelper {
  
  public formatDate(date: string) {
    return new Intl.DateTimeFormat("en-CA", { dateStyle: "short" }).format(
      new Date(date)
    );
  }
}

export default new DateHelper()